module.exports = {
  overlay: {
    title: "Premium only",
    text: "This feature need premium account, contact us to get one."
  }
}


// WEBPACK FOOTER //
// ../i18n/en/premium.js